import React from 'react';
import { ProgramContainer } from '../../entities/formTemplateDataType';

type Props = {
  field?: {
    Value?: string;
  };
  isEng: boolean;
  callback: (programContainer: ProgramContainer) => void;
};

const UnorderList: React.FC<Props> = ({ field, isEng, callback }) => {
  const valList = field?.Value?.split(',') || [];
  const htmlArray = [];

  valList.forEach((item, index) => {
    htmlArray.push(
      <li key={index} className="list-item">
        {item}
      </li>
    );
  }); 

  return <ul>{htmlArray}</ul>;
};

export default UnorderList;
